import React, { useState } from 'react';

import { IconButton } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Skeleton from '@material-ui/lab/Skeleton';
import { isNil } from 'lodash';

import { ReactComponent as InfoIcon } from 'pages/Teachers/ClassroomInsights/assets/tomorrow-focus-icon.svg';
import PreviewField from 'pages/Teachers/shared/PreviewField';
import { colors } from 'theme/palette';
import { formatRelativeTime } from 'utils/date';

import Typography from 'components/Typography';

import styles from './style.module.scss';

const LearningGaps = ({
  commonIssues,
  isLoading,
  isProcessing,
  lastUpdatedAt
}) => {
  const [loadAllStudents, setLoadAllStudents] = useState([]);
  const [descriptionDisplayed, setDescriptionDisplayed] = useState([]);

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <div>
          <div className={styles.headerTitle}>
            <InfoIcon />
            <Typography variant="S-TEAXT-2" color={colors.grey2}>
              Key Learning Gaps to Address
            </Typography>
          </div>
          {isProcessing && (
            <Typography className={styles.processing}>
              Processing new uploads...
            </Typography>
          )}
          {lastUpdatedAt && (
            <div>Updated {formatRelativeTime({ date: lastUpdatedAt })}</div>
          )}
        </div>
      </header>

      <Divider className={styles.divider} />
      <div className={styles.commonIssues}>
        {(isLoading || isNil(commonIssues)) && (
          <>
            {Array.from({ length: 2 }).map((_, i) => (
              <Skeleton key={i} animation="wave" height={100} />
            ))}
          </>
        )}
        {!isNil(commonIssues) && commonIssues?.length === 0 && !isLoading && (
          <div className={styles.noIssues}>
            No learning gaps to be addressed today.
          </div>
        )}
        {!isLoading &&
          commonIssues?.length !== 0 &&
          commonIssues?.map((issue, idx) => (
            <div key={idx} className={styles.errorSection}>
              <header className={styles.sectionHeader}>
                <div>
                  <Typography variant="S-TEAXT-2">{issue.name}</Typography>
                </div>
                <div>
                  <div className={styles.studentCount}>
                    {issue.students.length} Students
                  </div>
                  <IconButton
                    className={styles.loadMore}
                    onClick={() => {
                      if (!descriptionDisplayed.includes(idx))
                        setDescriptionDisplayed((prev) => [...prev, idx]);
                      else
                        setDescriptionDisplayed((prev) =>
                          prev.filter((i) => i !== idx)
                        );
                    }}
                  >
                    <ExpandMoreIcon
                      style={{
                        transform: descriptionDisplayed.includes(idx)
                          ? 'rotate(180deg)'
                          : 'rotate(0deg)',
                        transition: 'transform 0.3s ease'
                      }}
                    />
                  </IconButton>
                </div>
              </header>
              {descriptionDisplayed.includes(idx) && (
                <div className={styles.content}>
                  <PreviewField initialValue={issue.description} />

                  <div className={styles.students}>
                    {issue.students.length > 2 &&
                      !loadAllStudents.includes(idx) && (
                        <>
                          {issue.students.slice(0, 2).map((student, index) => (
                            <div key={index} className={styles.student}>
                              {student}
                            </div>
                          ))}
                          <div
                            className={styles.loadMore}
                            onClick={() =>
                              setLoadAllStudents((prev) => [...prev, idx])
                            }
                          >
                            + {issue.students.length - 2} more
                          </div>
                        </>
                      )}
                    {(issue.students.length < 3 ||
                      loadAllStudents.includes(idx)) && (
                      <>
                        {issue.students.map((student, index) => (
                          <div key={index} className={styles.student}>
                            {student}
                          </div>
                        ))}
                        {issue.students.length > 2 && (
                          <div
                            className={styles.loadMore}
                            onClick={() =>
                              setLoadAllStudents((prev) =>
                                prev.filter((i) => i !== idx)
                              )
                            }
                          >
                            show less
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
          ))}
      </div>
    </div>
  );
};

export default LearningGaps;
